import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IDeleteTasksDialogOptions } from './delete-tasks-dialog-options.interface';
import { IDeleteTaskList } from './delete-tasks.interface';
import * as _ from 'lodash';
import moment from 'moment';
@Component({
  selector: 'app-delete-tasks-dialog',
  templateUrl: 'delete-tasks-dialog.component.html',
})

export class DeleteTasksDialogComponent implements OnInit, OnDestroy {
  dialog: MatDialogRef<any>;
  modalOptions!: IDeleteTasksDialogOptions;
  data: IDeleteTaskList[] = [];
  viewAppt: boolean = false;
  weekOrder = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado' ];
  constructor(
    public dialogRef: MatDialogRef<any>,
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.modalOptions.title = this.modalOptions.title ?? 'Confirmacion';
    this.modalOptions.message = this.modalOptions.message ?? 'Esta seguro?';
    this.modalOptions.yesButtonLabel = this.modalOptions.yesButtonLabel ?? 'Aceptar';
    this.modalOptions.noButtonLabel = this.modalOptions.noButtonLabel ?? 'Cancelar';
    this.data = this.modalOptions.data;
    this.data.forEach(e => {
      let indexDate = moment(e.startDate).weekday();
      e.dayOfWeek = this.weekOrder[indexDate];
      if (e.timetracks.length > 0 || e.billingdocuments.length > 0 || e.deliverynotes.length > 0) {
        e.canDeleted = false;
      } else {
        e.canDeleted = true;
      }
    });
  }

  ngOnDestroy() {
    
  }
}
